export const readCourseCertificatesPermission = 'credentials.course-certificates.read'
export const writeCourseCertificatesPermission = 'credentials.course-certificates.write'

/** The certificate templates a course gives. */
export function courseCertificatesApi(courseId: string): string {
  return `/credentials/v1/courses/${encodeURIComponent(courseId)}/certificate-templates`
}

/** The certificate templates a course of an organization may give, for the chooser. */
export const certificateTemplateChoicesApi = '/credentials/v1/courses/certificate-template-choices'
